import React from "react";
import BarChart from "../../../components/BarChart/BarChart";
import { formatLocale } from "d3";

const ChronischeZiekte = () => {
	const localeFormatter = formatLocale({
		decimal: ",",
		thousands: "."
	});

	const formatValueTooltip = val =>
		localeFormatter.format(",.0f")(val) + " mensen per duizend personen";
	const formatValueY = val => localeFormatter.format(",.0f")(val);

	const data = [
		{ key: "85 jaar of ouder", value: 852.9 },
		{ key: "80 tot 85 jaar", value: 819.9 },
		{ key: "75 tot 80 jaar", value: 768.5 },
		{ key: "70 tot 75 jaar", value: 702.6 },
		{ key: "65 tot 70 jaar", value: 618.1 },
		{ key: "60 tot 65 jaar", value: 527.5 },
		{ key: "55 tot 60 jaar", value: 424.7 },
		{ key: "50 tot 55 jaar", value: 325.4 },
		{ key: "45 tot 50 jaar", value: 240.8 },
		{ key: "40 tot 45 jaar", value: 181.3 },
		{ key: "35 tot 40 jaar", value: 145.0 },
		{ key: "30 tot 35 jaar", value: 121.8 },
		{ key: "25 tot 30 jaar", value: 109.1 },
		{ key: "20 tot 25 jaar", value: 99.1 },
		{ key: "15 tot 20 jaar", value: 97.9 },
		{ key: "10 tot 15 jaar", value: 105.7 },
		{ key: "5 tot 10 jaar", value: 116.2 },
		{ key: "0 tot 5 jaar", value: 158.9 }
	];

	return (
		<div className="vis-chronische-ziekte">
			<BarChart
				data={data}
				margin={{ top: 10, right: 0, bottom: 10, left: 150 }}
				barHeight={30}
				domain={[0, 855]}
				color={{ fill: "#333", stroke: "#fff" }}
				formatValueTooltip={formatValueTooltip}
				formatValueY={formatValueY}
				padding={0.2}
				ticks={0}
			/>

			<div className="vis-credit">
				<p>
					Aantal mensen dat in 2016 contact had met de huisarts voor een
					chronische ziekte,<br />per duizend personen</p>
				<p>Bron: Staat van Volksgezondheid en Zorg</p>
			</div>
		</div>
	);
};

export default ChronischeZiekte;
